import React, { useEffect } from 'react';

import { PageLayout } from 'components/PageLayout';
import { ScrollToTop } from 'components/ScrollToTop';
import { useMerchant } from 'hooks/context/merchant';
import { GiftCardForm } from 'routes/GiftCard/Form';
import { BusinessInfo } from 'routes/Menu/BusinessInfo';
import { RouteFC } from 'util/routeTypes';
import styles from './styles.module.scss';
import { MenuHeader } from 'routes/Menu/MenuHeader';
import { useSmartNavigate } from 'hooks/useSmartNavigate';
import { heapTrack } from 'util/Analytics';

export const MerchantGiftCardOnly: RouteFC = () => {
  const navigate = useSmartNavigate();
  const { isLoading, merchant } = useMerchant();

  useEffect(() => {
    const hasOtherEnabledServices = Object.values(merchant?.onlineServices || {}).filter(service => !!service?.enabled).length > 1;
    const hasGiftCardAndOtherServicesEnabled = merchant?.onlineServices?.GIFT_CARDS?.enabled && hasOtherEnabledServices;

    if (hasGiftCardAndOtherServicesEnabled) heapTrack('gift-card-only-page-visit');

    if ((!isLoading && !merchant) || isLoading || hasGiftCardAndOtherServicesEnabled) return;

    navigate('~', { replace: true });
  }, [isLoading, merchant, navigate]);

  return (
    <ScrollToTop>
      <PageLayout header={<MenuHeader hideCategories />} forceStandardClasses customMainClass={styles.wrapper}>
        <div className={styles.mainContainer}>
          <BusinessInfo hideServiceHours />
          <GiftCardForm />
        </div>
      </PageLayout>
    </ScrollToTop>
  );
};
